export const CourseSearchViewTemplate = {
  hil: 3,
  render: {
    templates: ['cached://search_results_list_template'],
    view_template: '@eab-aip/ai-template-entity/ai-template-entity-list-filter'
  },
  runtime: {
    startup: [
      '[reference]{ /view }',
      '[reference]{ /entities }',
      '[reference]{ /entity_filters }',
      '[reference]{ /entities_bulk_actions }'
    ],
    tasks: {
      view: {
        $is: 'task',
        model: {
          title: 'Search for Courses',
          filter_heading: 'Search Preferences',
          list_heading: 'Search Results'
        },
        settings: {
          workflow: {
            disallow_borders: false,
            settings: {
              hidden: {
                visibility_control_left: false
              }
            }
          }
        }
      },
      entity_filters: {
        $is: 'task',
        model: '[reference]{ /filter_preferences/value }',
        type: {
          fields: {
            $is: 'drf_api',
            settings: {
              uri: '/api/v1/cat/course_search/fields/?application=scheduler',
              request: {
                headers: {
                  'user-mode': 'student'
                }
              },
              options: {
                authorization: {
                  type: 'csrf'
                }
              },
              interceptors: ['/api/request/authorization']
            },
            after_modifiers: [
              {
                $is: 'series',
                model_override: {
                  settings: {
                    $is: 'condition',
                    settings: {
                      if: {
                        left: '[value]{ /render_type }',
                        comparator: '==',
                        right: 'combobox'
                      },
                      is_true: {
                        $is: 'f1',
                        settings: {
                          method: 'merge',
                          arguments: [
                            'onto',
                            {
                              $is: 'f1',
                              settings: {
                                method: 'read',
                                arguments: ['/settings', {}]
                              }
                            },
                            { multiple: true }
                          ]
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      },
      add_course_to_term: {
        $is: 'api',
        before_modifiers: [] as Array<Record<string, unknown>>,
        settings: {
          uri: `/api/v1/ap3/studentplans/studentplanitems-infer-term/`,
          request: {
            manual: true,
            method: 'POST',
            headers: {
              'user-mode': 'student'
            }
          },
          options: {
            authorization: {
              type: 'csrf'
            }
          },
          interceptors: ['/api/request/authorization']
        },
        failure: [
          {
            $is: 'exec',
            settings: {
              path: '/hip/fn/notify',
              argument: {
                status: 'warning',
                title: `Error with adding course(s) happened, please try again`
              }
            }
          }
        ],
        success: [
          {
            $is: 'exec',
            before_guards: [
              {
                $is: 'guard',
                settings: {
                  comparator: '>=',
                  left: '[value]{/success/length}',
                  right: 1
                }
              }
            ],
            model_fallback: true,
            settings: {
              path: '/hip/fn/notify',
              argument: {
                title: 'Successfully added&nbsp;[value]{/success/length} &nbsp;course(s)',
                status: 'success',
                details: {
                  $is: 'condition',
                  settings: {
                    if: {
                      comparator: '>=',
                      left: '[value]{/success/length}',
                      right: 1
                    },
                    is_false: '',
                    is_true: {
                      $is: 'join',
                      operator: 'append',
                      tokens: [
                        `<ul style="margin-top: 0rem; padding-left: 1rem">`,
                        {
                          $is: 'series',
                          settings: {
                            path: '/success'
                          },
                          model: '<li>[value]{/course_title}</li>',
                          after_modifiers: [
                            {
                              $is: 'f1',
                              settings: {
                                method: 'join',
                                arguments: ['']
                              }
                            }
                          ]
                        },
                        '</ul>'
                      ]
                    }
                  }
                }
              }
            }
          },
          {
            $is: 'exec',
            model_fallback: true,
            before_guards: [
              {
                $is: 'guard',
                settings: {
                  comparator: '>=',
                  left: '[value]{ /failures/length }',
                  right: 1
                }
              }
            ],
            settings: {
              path: '/hip/fn/notify',
              argument: {
                title: `Failed to add&nbsp;[value]{/failures/length} &nbsp;course(s)`,
                status: 'warning',
                details: {
                  $is: 'join',
                  operator: 'append',
                  tokens: [
                    `<ul style="margin-top: 0rem; padding-left: 1rem">`,
                    {
                      $is: 'series',
                      settings: {
                        path: '/failures'
                      },
                      model: '<li>[value]{/message}</li>',
                      after_modifiers: [
                        {
                          $is: 'f1',
                          settings: {
                            method: 'join',
                            arguments: ['']
                          }
                        }
                      ]
                    },
                    '</ul>'
                  ]
                }
              }
            }
          }
        ]
      },
      filter_api: {
        $is: 'api',
        before_modifiers: [
          {
            $is: 'f1',
            settings: {
              method: 'filter',
              arguments: [(c: unknown) => c !== '']
            }
          },
          '[assignment]{ /filter_preferences }'
        ],
        settings: {
          uri: `/api/v1/cat/course_search/`,
          request: {
            manual: true,
            method: 'GET',
            headers: {
              'user-mode': 'student'
            }
          },
          options: {
            authorization: {
              type: 'csrf'
            }
          },
          interceptors: ['/api/request/authorization', '/api/request/query', '/api/response/query'],
          include_field: ''
        },
        failure: [
          {
            $is: 'exec',
            settings: {
              path: '/hip/fn/notify',
              argument: {
                status: 'warning',
                title: `Error with Course Search, please try again`
              }
            }
          },
          '[invocation]{ /entity_filters }'
        ],
        success: ['[invocation]{ /entity_filters }', '[assignment]{ /entities }']
      },
      filter_preferences: {
        $is: 'task'
      },
      entities_bulk_actions: {
        $is: 'task',
        type: {
          fields: {
            add_course_to_term: {
              title: 'Add Courses To Term',
              value: {
                in: '[reference] { /add_course_to_term }'
              }
            }
          }
        }
      },
      entities: {
        $is: 'task',
        settings: {
          mode: 'item',
          template: 'cached://search_results_list_template',
          allow_preprocessed_input: true,
          list: {
            hidden: {
              add_row: true,
              clear_all_limits: true,
              global_search: true,
              pagination_controls: false,
              pagination_row_size: false,
              pagination_row_message: false
            },
            subtitle: 'Courses',
            allow: {
              row_selections: true
            },
            messages: {
              bulk_actions: {
                title: 'Add to Term',
                description: 'Perform bulk add on selected row(s)'
              },
              state_initial: {
                title: 'Enter your search criteria to find courses offered this term',
                description: 'Note that not all courses offered are guaranteed to have availability'
              },
              state_loading: {
                title: 'Fetching Course Results',
                description: ''
              },
              state_empty: {
                title: 'No Courses Found',
                description: '0 courses found. Adjust your filter preferences to view courses.'
              }
            }
          }
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/components/search_and_add_courses/course_search_view_template.ts